import { render } from "./UpdateBackupOffering.vue?vue&type=template&id=16070afc&scoped=true"
import script from "./UpdateBackupOffering.vue?vue&type=script&lang=js"
export * from "./UpdateBackupOffering.vue?vue&type=script&lang=js"

import "./UpdateBackupOffering.vue?vue&type=style&index=0&id=16070afc&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16070afc"]])

export default __exports__